// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import jobsMessages from './messages';
import sharedMessages from '../../../shared/Footer/messages';
import { VERTICAL_NAMES } from '../../../../common/constants/common';

type Props = {
  verticalName: string,
  url: string,
};

const { jobsGuidesTitle } = jobsMessages;
const { guidesTitle } = sharedMessages;

export default function GuideLink({ verticalName, url }: Props): React.Node {
  if (!url) {
    return null;
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer nofollow">
      {verticalName === VERTICAL_NAMES.jobs ? (
        <FormattedMessage {...jobsGuidesTitle} />
      ) : (
        <FormattedMessage {...guidesTitle} />
      )}
    </a>
  );
}



// WEBPACK FOOTER //
// ./app/components/mobile/Footer/GuideLink/index.js